import { render, staticRenderFns } from "./form-submission-default-field.vue?vue&type=template&id=887735e8&scoped=true"
import script from "./form-submission-default-field.vue?vue&type=script&lang=js"
export * from "./form-submission-default-field.vue?vue&type=script&lang=js"
import style0 from "./form-submission-default-field.vue?vue&type=style&index=0&id=887735e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887735e8",
  null
  
)

export default component.exports